import React from "react";
import { Nav } from "react-bootstrap";
import { useLocation, Link, withRouter } from "react-router-dom";
import {RiSurveyFill, RiHome4Fill,RiLinksFill,RiFolderUserFill} from "react-icons/ri";


function SidebarMenu(props) {
    let location = useLocation();
    return (
        <div id="sidebar-wrapper" className="bg-secondary">
            <Nav variant="pills"
                className="h-100 flex-column d-block bg-secondary text-light sidebar"
                activeKey={location.pathname}
            >
                <Nav.Link
                    className="text-light" 
                    eventKey="/" 
                    as={Link} to="/"
                >
                    <RiHome4Fill /> Home
                </Nav.Link>
                <hr/>
                {/* <Nav.Link
                    className="text-light"
                    eventKey="/survey-builder"
                    as={Link}
                    to="/survey-builder"
                >
                    Form builder
                </Nav.Link> */}
                <Nav.Link
                    className="text-light"
                    eventKey="/endpoint/list"
                    as={Link}
                    to="/endpoint/list"
                >
                    <RiLinksFill /> Endpoint
                </Nav.Link>
                <Nav.Link
                    className="text-light"
                    eventKey="/survey/list"
                    as={Link}
                    to="/survey/list"
                >
                    <RiSurveyFill /> Questionari
                </Nav.Link>
                <hr/>
                <Nav.Link
                    className="text-light"
                    eventKey="/user/list"
                    as={Link}
                    to="/user/list"
                >
                    <RiFolderUserFill /> Utenti
                </Nav.Link>
            </Nav>
        </div>
    );
}

export default withRouter(SidebarMenu);
